"use client";
import Script from "next/script";
import { initializeLogger } from ".";

export const FeLoggerClient = ({
  homepagePaths,
  subscriptionKey,
  src,
}: {
  homepagePaths: Set<string>;
  subscriptionKey: string;
  src: string;
}) => (
  <Script
    onReady={() => {
      initializeLogger({
        subscriptionKey,
        ...(homepagePaths.has(document.location.pathname) && {
          additionalData: {
            homepage: "DotNext",
          },
        }),
      })();
    }}
    src={src}
  />
);
